<script>
  // Перенос ShopHead из shop.tsx — одна шапка у всех семи разделов магазина.
  import { t } from '../../i18n.js';
  import { cc } from '../partsfn.js';
  import Ico from '../ico.svelte';
  import Sechead from './sechead.svelte';
  export let title = '';
  export let balance = 0;
</script>

<Sechead kicker={t('m.sh.kicker')} {title}>
  <svelte:fragment slot="meta">
    <span class="mn-ico-txt"><slot name="extra" /><Ico n="currency" s={15} /><b>{cc(balance)}</b></span>
  </svelte:fragment>
</Sechead>
